import TaiBaseWidget from "../base.widget.js";
import template from './Numberic.template.html'

class NumberWidget extends TaiBaseWidget {

    template() {
        return template
    }

    getValue() {
        const val = this.fieldModel.userResponse
        return val.length > 0 ? Number(val) : '';
    }
}

export default NumberWidget;